/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_SportInputs */

const en_field_sport = /** @type {(inputs: Field_SportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sport`)
};

const es_field_sport = /** @type {(inputs: Field_SportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deporte`)
};

const fr_field_sport = /** @type {(inputs: Field_SportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sport`)
};

const de_field_sport = /** @type {(inputs: Field_SportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sportart`)
};

const ja_field_sport = /** @type {(inputs: Field_SportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スポーツ`)
};

const zh_field_sport = /** @type {(inputs: Field_SportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`运动项目`)
};

const ar_field_sport = /** @type {(inputs: Field_SportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الرياضة`)
};

const id_field_sport = /** @type {(inputs: Field_SportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Olahraga`)
};

const it_field_sport = /** @type {(inputs: Field_SportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sport`)
};

const ru_field_sport = /** @type {(inputs: Field_SportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вид спорта`)
};

const pt_field_sport = /** @type {(inputs: Field_SportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporte`)
};

const ko_field_sport = /** @type {(inputs: Field_SportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스포츠 종목`)
};

/**
* | output |
* | --- |
* | "Sport" |
*
* @param {Field_SportInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_sport = /** @type {((inputs?: Field_SportInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_SportInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_sport(inputs)
	if (locale === "es") return es_field_sport(inputs)
	if (locale === "fr") return fr_field_sport(inputs)
	if (locale === "de") return de_field_sport(inputs)
	if (locale === "ja") return ja_field_sport(inputs)
	if (locale === "zh") return zh_field_sport(inputs)
	if (locale === "ar") return ar_field_sport(inputs)
	if (locale === "id") return id_field_sport(inputs)
	if (locale === "it") return it_field_sport(inputs)
	if (locale === "ru") return ru_field_sport(inputs)
	if (locale === "pt") return pt_field_sport(inputs)
	return ko_field_sport(inputs)
});